import { render, staticRenderFns } from "./GalleryTab.vue?vue&type=template&id=580bae01&scoped=true&"
import script from "./GalleryTab.vue?vue&type=script&lang=js&"
export * from "./GalleryTab.vue?vue&type=script&lang=js&"
import style0 from "./GalleryTab.vue?vue&type=style&index=0&id=580bae01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580bae01",
  null
  
)

export default component.exports